/**
 * ReportSubmitted screen styles - V3 Design System
 */

import { StyleSheet, Dimensions } from 'react-native';
import { heightPercentageToDP as hp, widthPercentageToDP as wp } from 'react-native-responsive-screen';

import AppStyles from '../../AppStyles';

const screenWidth = Dimensions.get('window').width;

const styles = StyleSheet.create({
  container: {
    width: '90%',
    maxWidth: 600,
    backgroundColor: AppStyles.colorSet.brandPrimary,
    alignSelf: 'center',
    padding: AppStyles.spacing.xxl,
    borderRadius: AppStyles.borderRadii.lg,
    ...AppStyles.styleSet.shadowMedium,
  },
  bottomContainer: {
    flexDirection: 'column',
    backgroundColor: AppStyles.colorSet.brandPrimary,
    alignSelf: 'center',
    width: '90%',
    maxWidth: 600,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: AppStyles.borderRadii.lg,
    padding: AppStyles.spacing.xxl,
    marginTop: AppStyles.spacing.xl,
    ...AppStyles.styleSet.shadowMedium,
  },
  subContainer: {
    maxWidth: '100%',
    alignSelf: 'center',
    paddingVertical: AppStyles.spacing.md,
  },
  bottomSubContainer: {
    width: '100%',
    maxWidth: '100%',
    paddingVertical: AppStyles.spacing.lg,
    alignSelf: 'center',
  },
  imageSubContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: AppStyles.spacing.xl,
    gap: AppStyles.spacing.lg,
  },
  image: {
    maxWidth: 150,
    width: wp(25),
    height: screenWidth >= 800 ? 50 : 40,
    borderRadius: AppStyles.borderRadii.sm,
  },
  button: {
    backgroundColor: AppStyles.colorSet.brandPrimary,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: AppStyles.borderRadii.md,
    height: hp(8),
    width: '80%',
    alignSelf: 'center',
  },
  linkText: {
    color: AppStyles.colorSet.mainThemeForegroundColor,
    textDecorationLine: 'underline',
  },
});

export default styles;
